/**
 * Roles tal como los manda el backend en el JWT.
 *
 * La grafia importa: las rutas, el menu y los guards comparan el rol del
 * token contra estos strings, asi que una diferencia de mayusculas deja al
 * usuario sin acceso a ninguna ruta y sin menu. Usar estas constantes en vez
 * de literales sueltos evita que vuelva a pasar.
 */
export const ROLES = {
  admin: 'Admin',
  supervisor: 'Supervisor',
  agent: 'Agent',
  sales: 'Sales',
  preSales: 'Pre-sales',
  workshop: 'Workshop',
  logistics: 'Logistics',
  telemarketing: 'Telemarketing',
} as const;

export type Role = (typeof ROLES)[keyof typeof ROLES];

/** Todos los roles asignables a un usuario. */
export const ALL_ROLES: Role[] = Object.values(ROLES);
